// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__f2VLQ","checkbox":"Checkbox_checkbox__71xI9","checked":"Checkbox_checked__XxrrH","invalid":"Checkbox_invalid__EvDC8","icon":"Checkbox_icon__Xjbrs"};